import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { addDays, format } from 'date-fns';
import { cloneDeep } from 'lodash-es';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { formPaths } from '@shared/constants/form-paths.const';

/** Replica il calcolo VBS DataApprovazioneN_60 = DataApprovazioneN + 60 giorni (script.vbs 7060-7075).
 * Nel VBS scattava solo al caricamento bilancio da Excel; in NCR DataApprovazione1/2 sono campi
 * utente diretti (dati-bilancio-bis-form.service.ts), quindi qui è reattivo sul campo base. */
export const setDatiBilancioBisDataApprovazioneListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_DataApprovazione1(form, store);
    my_DataApprovazione2(form, store);
};

const my_DataApprovazione1 = (form: FormGroup, store: Store<Revisione53State>): void => {
    const datiBilancioGroup = getGroup(form, formPaths.datiBilancio);
    const control = getControl(datiBilancioGroup, 'my_DataApprovazione1');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((value: string) => {
        const dataApprovazione1_60 = calcolaDataPiu60Giorni(value);
        getControl(datiBilancioGroup, 'my_DataApprovazione1_60').patchValue(dataApprovazione1_60, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione1_60 = dataApprovazione1_60;
            return myVerbaleClone;
        });
    });
};

const my_DataApprovazione2 = (form: FormGroup, store: Store<Revisione53State>): void => {
    const datiBilancioGroup = getGroup(form, formPaths.datiBilancio);
    const control = getControl(datiBilancioGroup, 'my_DataApprovazione2');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((value: string) => {
        const dataApprovazione2_60 = calcolaDataPiu60Giorni(value);
        getControl(datiBilancioGroup, 'my_DataApprovazione2_60').patchValue(dataApprovazione2_60, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataApprovazione2_60 = dataApprovazione2_60;
            return myVerbaleClone;
        });
    });
};

const calcolaDataPiu60Giorni = (value: string): string => (isNilOrEmpty(value) ? '' : format(addDays(new Date(value), 60), 'yyyy-MM-dd'));
